const css = `.style-module__root__26kw6 {
	display: contents;
}
`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "root": "style-module__root__26kw6"
};